"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const top_toolbar_styles_1 = require("./top_toolbar.styles");
const app_icon_1 = require("../icons/app_icon");
const ToolBarIcon = ({ tool, active, handleClick }) => {
    const theme = (0, react_1.useTheme)();
    const color = active ? theme.colors.white : undefined;
    return ((0, jsx_runtime_1.jsx)(top_toolbar_styles_1.IconWrapper, Object.assign({ role: "button", alignItems: "center", justifyContent: "center", onClick: handleClick, active: active }, { children: (0, jsx_runtime_1.jsx)(app_icon_1.AppIcon, { name: tool.iconName, color: color }) }), tool.iconName));
};
exports.default = ToolBarIcon;
//# sourceMappingURL=tool_bar_icon.js.map